import {
  ApisauceInstance
} from 'apisauce';

// Url
import { url } from '../api.url';

const downloadFile = (api: ApisauceInstance) => {
  const downloadLib = (formData: any) => api.get(url.downloadLib({catNumber: formData.catNumber, type: formData.type}), {});
  const downloadSDFAnyIdsSdf = (ids: string[], sdfVersion: string) => api.post(`${url.downloadSDFAnyIdsSdf}?sdfVersion=${sdfVersion}`, ids || {});

  return {
    downloadLib,
    downloadSDFAnyIdsSdf
  };
};

export default downloadFile;
